// extracted by mini-css-extract-plugin
export default {"complete":"styles_complete__I6hEj","submit":"styles_submit__Sv4+U"};